import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

window.einsteinSwiper = Swiper;

einsteinSwiper.use([Autoplay, Navigation, Pagination, EffectCoverflow]);